import styled from "styled-components";

export const StyledTitle = styled.h4`
    font-size: ${(props) => props.theme.typography.heading.small.fontSize};
    font-weight: ${(props) => props.theme.typography.heading.small.fontWeight};
    line-height: ${(props) => props.theme.typography.heading.small.lineHeight};
    margin-top: 0;
`;

export const ButtonWrapper = styled.div`
    margin: 0 ${(props) => props.theme.spacing.xs};
`;

export const StyledWrapper = styled.div`
    padding: ${(props) => props.theme.spacing.sm};
    padding-top: ${(props) => props.theme.spacing.xxl};
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StyledText = styled.div`
    display: flex;
    font-size: ${(props) => props.theme.typography.body.normal.fontSize};
    font-weight: ${(props) => props.theme.typography.body.normal.fontWeight};
    line-height: ${(props) => props.theme.typography.body.normal.lineHeight};
    color: ${(props) => props.theme.colors.neutral.neutral600};
`;

export const NotificationRadio = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${(props) => props.theme.spacing.sm};
`;

export const RadioInput = styled.input`
    height: 16px;
    width: 16px;
    margin-right: ${(props) => props.theme.spacing.sm};
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: ${(props) => props.theme.spacing.sm};
    gap: ${(props) => props.theme.spacing.xxs};
`;
